export default __webpack_public_path__ + "static/media/clashingSoon2x.67e8fa5c.png";